<style lang="scss" scoped>
textarea.form-control {
  max-height: none;
}

.card {
  margin-bottom: 0px;
}

button.accordion {
  width: 100%;
  text-align: left;
  margin: 0px;
  background-color: #fff !important;
  color: #000 !important;
}

button.accordion:hover {
  background-color: #e3e3e3 !important;
  color: #000 !important;
}

.card .card-header {
  padding: 1px;
}
</style>

<template>
  <div v-if="loading" class="card-body p">
    <div class="d-flex justify-content-around">
      <i class="fas fa-spinner fa-spin fa-10x"></i>
    </div>
  </div>
  <div v-else>
    <modal
      name="modal-delete-message"
      width="60%"
      height="auto"
      style="overflow-y: scroll"
    >
      <div class="card">
        <div class="card-header p-2 bg-default text-center text-white">
          Nachricht löschen
        </div>
        <div class="card-body pb-0 text-center">
          <div class="row">
            <div class="col-12 p-1 pb-4">
              Wollen Sie diese Nachricht <b>**UNWIEDERRUFLICH**</b> löschen?
              Eine gelöschte Nachricht kann nicht wiederhergestellt werden
              <br />
              <span v-if="modal.isFromFake">
                Dem Moderator <i>{{ modal.moderator }}</i> wird durch das
                Löschen dieser Nachricht ein IN abgezogen
              </span>
              <span v-else>
                Durch das Löschen der Nachricht wird dem Mitglied
                {{ modal.price }} {{ currency }} wieder gutgeschrieben.
              </span>
            </div>
          </div>
          <div class="row">
            <div v-if="modal.isFromFake" class="col p-1">
              <a
                @click="
                  $modal.hide('modal-delete-message');
                  deleteMessage(false);
                "
                class="btn btn-block btn-success text-white rounded"
              >
                Nachricht löschen
              </a>
            </div>
            <div v-if="!modal.isFromFake" class="col p-1">
              <a
                @click="
                  $modal.hide('modal-delete-message');
                  deleteMessage(true);
                "
                class="btn btn-block btn-success text-white rounded"
              >
                Nachricht löschen. {{ currency }} erstatten.
              </a>
            </div>
            <div v-if="!modal.isFromFake" class="col p-1">
              <a
                @click="
                  $modal.hide('modal-delete-message');
                  deleteMessage(false);
                "
                class="btn btn-block btn-warning text-white rounded"
              >
                Nachricht löschen. {{ currency }} NICHT erstatten.
              </a>
            </div>
            <div class="col p-1">
              <a
                @click="$modal.hide('modal-delete-message')"
                class="btn btn-block btn-danger text-white rounded"
              >
                Nachricht nicht löschen
              </a>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div>
      <h4>Dialog zwischen #{{ idFirst }} und #{{ idLast }}</h4>
      <router-link v-if="isAuthAdmin" :to="'/dialogkontrolle/'">
        <div class="btn btn-primary">Zurück</div>
      </router-link>
      <v-button
        v-if="isAuthAdmin"
        @click.native="toggleDialogDisabled"
        :working="settingDialogDisabled"
        class="btn btn-danger float-right"
      >
        {{ dialogDisabledText }}
      </v-button>
    </div>
    <div class="card">
      <div class="card-header" id="headingOne">
        <h3 class="mb-0">
          <button
            @click="showInfos = !showInfos"
            class="accordion btn btn-link"
            type="button"
          >
            Infos
          </button>
        </h3>
      </div>
      <div v-if="showInfos" class="card-body">
        <div class="row mb-3">
          <div class="col-4" v-if="profileLeft">
            <h5>
              <router-link
                v-if="isAuthAdmin"
                :to="getProfileLink(profileLeft)"
                >{{ profileLeft.name }}</router-link
              >
              <span v-else>{{ profileLeft.name }}</span>
              <span
                v-if="profileLeft.deleted_at !== null"
                class="badge badge-danger ml-3"
                >GELÖSCHT</span
              >
            </h5>
            <div class="form-group">
              Fake: <span v-html="getMarkerHtml(profileLeft.is_fake)"></span>
            </div>
            <div class="form-group">
              <label for="profile-left-internal"
                >Info Intern (admin -> admin)</label
              >
              <textarea
                class="form-control p-2"
                id="profile-left-internal"
                rows="4"
                :value="profileLeft.internal_notes"
                disabled
              ></textarea>
            </div>
            <div class="form-group">
              <label for="profile-left-admin"
                >Info von Admin (admin -> moderator)</label
              >
              <textarea
                class="form-control p-2"
                id="profile-left-admin"
                rows="4"
                :value="profileLeft.admin_notes"
                disabled
              ></textarea>
            </div>
            <div class="form-group">
              <label for="profile-left-note">Info von Moderator</label>
              <dialog-note-textarea
                v-if="dialog"
                :dialogId="dialog.id"
                :fake="profileLeft.is_fake"
                :value="getDialogNote(profileLeft.is_fake)"
                :disabled="true"
                id="profile-left-note"
              ></dialog-note-textarea>
            </div>
          </div>
          <div class="col-4">
            <dialog-info-chat
              v-if="dialog"
              :dialogId="dialog.id"
              :messages="dialogInfoMessages"
              :adminViewing="true"
            ></dialog-info-chat>
          </div>
          <div class="col-4" v-if="profileRight">
            <h5>
              <router-link
                v-if="isAuthAdmin"
                :to="getProfileLink(profileRight)"
                >{{ profileRight.name }}</router-link
              >
              <span v-else>{{ profileRight.name }}</span>
              <span
                v-if="profileRight.deleted_at !== null"
                class="badge badge-danger ml-3"
                >GELÖSCHT</span
              >
            </h5>
            <div class="form-group">
              Fake: <span v-html="getMarkerHtml(profileRight.is_fake)"></span>
            </div>
            <div class="form-group">
              <label for="profile-right-internal"
                >Info Intern (admin -> admin)</label
              >
              <textarea
                class="form-control p-2"
                id="profile-right-internal"
                rows="4"
                :value="profileRight.internal_notes"
                disabled
              ></textarea>
            </div>
            <div class="form-group">
              <label for="profile-right-admin"
                >Info von Admin (admin -> moderator)</label
              >
              <textarea
                class="form-control p-2"
                id="profile-right-admin"
                rows="4"
                :value="profileRight.admin_notes"
                disabled
              ></textarea>
            </div>
            <div class="form-group">
              <label for="profile-right-note">Info von Moderator</label>
              <dialog-note-textarea
                v-if="dialog"
                :dialogId="dialog.id"
                :fake="profileRight.is_fake"
                :value="getDialogNote(profileRight.is_fake)"
                :disabled="true"
                id="profile-right-note"
              ></dialog-note-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog-scroller
      :infiniteScroll="true"
      :mirror="true"
      :idPartner="idFirst"
      :idProfile="idLast"
      :support="false"
    ></dialog-scroller>
  </div>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
import { defaultTrueHtml } from "@/js/defaultTrueHtml";
import DialogScroller from "@/components/DialogScroller";
import DialogNoteTextarea from "@/components/DialogNoteTextarea";
import DialogInfoChat from "@/components/Moderator/DialogInfoChat";

export default {
  components: {
    DialogScroller,
    DialogNoteTextarea,
    DialogInfoChat
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  created() {
    this.loadDialog();
    this.$bus.$on("show-modal", values => {
      this.$data.modal = values;
      this.$modal.show("modal-delete-message");
    });
  },
  data() {
    return {
      currency: Laravel.lang.currency,
      modal: [],
      loading: true,
      dialogInfoMessages: [],
      dialog: null,
      settingDialogDisabled: false,
      showInfos: false
    };
  },
  computed: {
    idFirst() {
      return Number(this.id.split("-")[0]);
    },
    idLast() {
      return Number(this.id.split("-")[1]);
    },
    messages() {
      return this.$store.getters["message/dialog"](this.idFirst, this.idLast);
    },
    profileLeft() {
      if (this.messages.length === 0) {
        return null;
      }

      return this.messages[this.messages.length - 1].sender_id === this.idFirst
        ? this.messages[this.messages.length - 1].sender
        : this.messages[this.messages.length - 1].receiver;
    },
    profileRight() {
      if (this.messages.length === 0) {
        return null;
      }

      return this.messages[this.messages.length - 1].sender_id === this.idLast
        ? this.messages[this.messages.length - 1].sender
        : this.messages[this.messages.length - 1].receiver;
    },
    fakeProfile() {
      return this.profileLeft.is_fake ? this.profileLeft : this.profileRight;
    },
    customerProfile() {
      return !this.profileLeft.is_fake ? this.profileLeft : this.profileRight;
    },
    dialogDisabledText() {
      let action = this.dialog.is_disabled ? "Entsperren" : "Sperren";
      return `Dialog ${action}`;
    },
    isAuthAdmin() {
      return this.$store.getters["user/meHasRole"]("admin");
    }
  },
  methods: {
    toggleDialogDisabled() {
      if (this.settingDialogDisabled) {
        return;
      }
      this.settingDialogDisabled = true;
      this.$http
        .post("/api/v1/dialog/toggleDisable", {
          dialog_id: this.dialog.id
        })
        .then(({ data }) => {
          this.dialog.is_disabled = !this.dialog.is_disabled;
          this.$notify({
            title: data,
            type: "success"
          });
        })
        .finally(() => {
          this.settingDialogDisabled = false;
        });
    },
    deleteMessage(coinsBack) {
      this.$http
        .post("/api/v1/message/delete/" + this.modal.message_id, {
          coinsBack: coinsBack
        })
        .then(() => {
          this.$notify({
            title: "Die Nachricht wurde gelöscht.",
            type: "success"
          });
          this.$store.commit("message/delete", this.modal.message_id);
        });
    },
    loadDialog() {
      this.loading = true;

      this.$http
        .get(`/api/v1/dialog/read/${this.id}`)
        .then(({ data }) => {
          this.dialog = data;
          this.showInfoMessages = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadDialogInfoMessages() {
      if (this.dialog) {
        this.$http
          .get("/api/v1/dialogInfoMessage", {
            params: {
              dialog_id: this.dialog.id
            }
          })
          .then(({ data }) => {
            this.dialogInfoMessages = data;
          });
      }
    },
    getProfileLink(profile) {
      return profile.is_fake
        ? `/fake/kartei/${profile.id}`
        : `/mitglieder/kartei/${profile.id}`;
    },
    getMarkerHtml(boolean) {
      if (boolean) {
        return defaultTrueHtml();
      }

      return defaultNullHtml();
    },
    getDialogNote(fake) {
      return fake ? this.dialog.fake_notes : this.dialog.customer_notes;
    }
  },
  beforeDestroy() {
    this.$store.commit("message/resetSkip", { id: this.id });
  },
  watch: {
    profileLeft() {
      this.loadDialogInfoMessages();
    }
  }
};
</script>

<style>
.contact__messages {
  max-width: auto;
}

.message__image {
  height: 55px;
  width: 55px;
}

.message__time {
  font-size: 0.7rem;
}
</style>
